import { useEffect, useState } from "react";
import { ContactoItem, getContactos, updateCorreo } from "../../services/contacto";

const useContacto = () => {
  const [contactos, setContactos] = useState<ContactoItem[]>([]);
  const [originales, setOriginales] = useState<Record<number, string>>({});
  const [isLoading, setIsLoading] = useState(false);
  const [savingId, setSavingId] = useState<number | null>(null);

  const fetchContactos = async () => {
    try {
      setIsLoading(true);
      const data = await getContactos();
      setContactos(data);
      const map: Record<number, string> = {};
      data.forEach((c) => {
        map[c.id] = c.correo;
      });
      setOriginales(map);
    } catch (e) {
      console.error("Error fetching contactos: ", e);
    } finally {
      setIsLoading(false);
    }
  };

  const setCorreo = (id: number, valor: string) => {
    setContactos((prev) => prev.map((c) => (c.id === id ? { ...c, correo: valor } : c)));
  };

  const guardarCorreo = async (id: number) => {
    const contacto = contactos.find((c) => c.id === id);
    if (!contacto) return;

    try {
      setSavingId(id);
      await updateCorreo({ id, correo: contacto.correo });
      setOriginales((prev) => ({ ...prev, [id]: contacto.correo }));
      alert("Correo actualizado");
    } catch (e) {
      console.error("Error ", e);
      alert("Ocurrió un error al actualizar el correo");
    } finally {
      setSavingId(null);
    }
  };

  const tieneCambios = (id: number) => {
    const contacto = contactos.find((c) => c.id === id);
    if (!contacto) return false;
    return contacto.correo !== (originales[id] ?? "");
  };

  useEffect(() => {
    fetchContactos();
  }, []);

  return {
    contactos,
    isLoading,
    savingId,
    setCorreo,
    guardarCorreo,
    tieneCambios,
  };
};

export default useContacto;
